module.exports = __webpack_public_path__ + "img/success-check.31c6f9ee.svg";